import React from 'react'
const LangContext = React.createContext({
    lang: "en",
    setLang: (l) => {}
});

export const LangProvider = LangContext.Provider

export default LangContext